import * as errorModel from './error';
import * as formattedPropertyModel from './formatted_property';
import * as hierarchyTreeModel from './hierarchy_tree_children';
import * as i18nConfigModel from './i18n_config';
import i18nConfigMock from './i18n_config_mock.json';
import * as layoutConfigModel from './layout_config';
import * as pageModel from './page';
import * as projectConfigModel from './project_config';
import * as tableDataModel from './table_data';
import tableDataMock from './table_data_mock.json';
import * as translationModel from './translation';

export {
  errorModel,
  formattedPropertyModel,
  hierarchyTreeModel,
  i18nConfigMock,
  i18nConfigModel,
  layoutConfigModel,
  pageModel,
  projectConfigModel,
  tableDataModel,
  tableDataMock,
  translationModel,
};
export default {
  errorModel,
  formattedPropertyModel,
  hierarchyTreeModel,
  i18nConfigMock,
  i18nConfigModel,
  layoutConfigModel,
  pageModel,
  projectConfigModel,
  tableDataModel,
  tableDataMock,
  translationModel,
};
